module.exports = __webpack_public_path__ + "img/card-img_1(768).2ceeebbd.png";